import React, { useState } from 'react';
import { getMobileSignInUrl, isMobileBrowser, openPlayerDexApp } from '../../auth/mobileSignInLink';
import { useTranslation } from '../../context/Internationalization';
import { LOGIN_ROUTE } from '../../routes';
import { Button, buttonVariants } from '../../shadcn/components/ui/button';
import { Separator } from '../../shadcn/components/ui/separator';
import StatusAlert from '../../Components/Common/StatusAlert';
import AuthLayout from './AuthLayout';
import appStoreBadge from '../../assets/images/store-badges/app-store.svg';
import googlePlayBadge from '../../assets/images/store-badges/google-play.svg';

export default function MobileSignInFallback() {
  const { t } = useTranslation();
  const [attempted, setAttempted] = useState(false);
  const mobile = isMobileBrowser();
  const validLink = Boolean(getMobileSignInUrl());

  const openApp = () => {
    setAttempted(true);
    // A deliberate tap avoids automatic redirects and popup/redirect loops.
    // Do not copy the credential into rendered markup or application storage.
    try { openPlayerDexApp(); } catch (_) { /* Browser may block custom schemes. */ }
  };

  return <AuthLayout>
    <div className="flex flex-col gap-6">
      <h1>{t('mobile_sign_in_title')}</h1>
      <p className="text-muted-foreground">{t('mobile_sign_in_description')}</p>
      {!validLink ? <StatusAlert severity="info">{t('mobile_sign_in_invalid')}</StatusAlert> : mobile ? <>
        <Button size="lg" onClick={openApp}>{t('mobile_sign_in_open')}</Button>
        {attempted && <StatusAlert severity="info" role="status">{t('mobile_sign_in_open_help')}</StatusAlert>}
      </> : <StatusAlert severity="info">{t('mobile_sign_in_desktop')}</StatusAlert>}
      <p className="text-sm text-muted-foreground">{t('mobile_sign_in_install_help')}</p>
      <div className="flex flex-wrap gap-4">
        <a href="https://apps.apple.com/gr/app/playerdex-academy/id1584881110" target="_blank" rel="noopener noreferrer" aria-label={t('download_on_app_store')}>
          <img src={appStoreBadge} alt="" className="block h-10 w-[135px]" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=app.playerdex.onetouchfootball" target="_blank" rel="noopener noreferrer" aria-label={t('get_it_on_google_play')}>
          <img src={googlePlayBadge} alt="" className="block h-10 w-[135px]" />
        </a>
      </div>
      <Separator />
      <p className="text-sm text-muted-foreground">{t('mobile_sign_in_manager_help')}</p>
      {/* Full navigation discards the action URL before Manager can bootstrap. */}
      <a href={LOGIN_ROUTE} referrerPolicy="no-referrer" className={buttonVariants({ variant: 'outline', className: 'h-auto min-h-9 whitespace-normal py-2' })}>{t('mobile_sign_in_manager')}</a>
    </div>
  </AuthLayout>;
}
